import CoverBlockHome from "../objects/elements/CoverBlockHome";
import PostCoverBlock from "../objects/elements/PostCoverBlock";
import ContainerBlock from "../objects/elements/ContainerBlock";
import FooterRow from "../objects/elements/FooterRow";
import CoverBlock from "../objects/elements/CoverBlock";
import CoverBlockQuoteSlider from "../objects/elements/CoverBlockQuoteSlider";

/**
 * Kijkt welk object er bij het element past en geeft een nieuwe instantie ervan terug.
 *
 * @param {HTMLElement} element
 *
 * @returns {WebsiteElement|null}
 */
export function elementFactory(element) {
    if (CoverBlockHome.is(element)) {
        return new CoverBlockHome(element);
    }

    if (PostCoverBlock.is(element)) {
        return new PostCoverBlock(element);
    }

    if (CoverBlockQuoteSlider.is(element)) {
        return new CoverBlockQuoteSlider(element);
    }

    if (CoverBlock.is(element)) {
        return new CoverBlock(element);
    }

    if (ContainerBlock.is(element)) {
        return new ContainerBlock(element);
    }

    if (FooterRow.is(element)) {
        return new FooterRow(element);
    }

    return null;
}